import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./EditBlog.css";

function EditBlog() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    author: "",
    tags: "",
  });
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [oldImage, setOldImage] = useState(null); // 🔹 store existing image URL
  const [loading, setLoading] = useState(false);

  // 🔸 Fetch current blog data
  useEffect(() => {
    const fetchBlog = async () => {
      const ref = doc(db, "blogs", id);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setForm({
          title: data.title,
          author: data.author,
          tags: data.tags ? data.tags.join(", ") : "",
        });
        setDescription(data.description || "");
        setOldImage(data.image || null); // 🔹 set existing image URL
      }
    };
    fetchBlog();
  }, [id]);

  // 🔸 Handle update
  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const ref = doc(db, "blogs", id);
      const slug = form.title.toLowerCase().replace(/\s+/g, "-");

      let imageUrl = oldImage; // 🔹 keep old image by default
      if (image) imageUrl = await uploadToCloudinary(image); // 🔹 if new uploaded

      await updateDoc(ref, {
        title: form.title,
        author: form.author,
        slug,
        tags: form.tags.split(",").map((t) => t.trim()),
        description,
        image: imageUrl,
      });

      alert("✅ Blog updated successfully!");
      navigate("/blog-manager"); // optional: redirect after update
    } catch (err) {
      console.error(err);
      alert("❌ Error updating blog!");
    }

    setLoading(false);
  };

  return (
    <div className="edit-blog-container">
      <h2>Edit Blog</h2>
      <form onSubmit={handleUpdate}>
        <input
          type="text"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          placeholder="Title"
          required
        />
        <input
          type="text"
          value={form.author}
          onChange={(e) => setForm({ ...form, author: e.target.value })}
          placeholder="Author"
        />
        <input
          type="text"
          value={form.tags}
          onChange={(e) => setForm({ ...form, tags: e.target.value })}
          placeholder="Tags (comma separated)"
        />

        <ReactQuill
          value={description}
          onChange={setDescription}
          theme="snow"
          modules={{
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ align: [] }],
              ["clean"],
            ],
          }}
        />

        {/* 🔹 Show old image preview */}
        {oldImage && (
          <div className="image-preview">
            <p>Current Image:</p>
            <img src={oldImage} alt="Current Blog" />
          </div>
        )}

        {/* 🔹 Upload new image */}
        <label>Change Image:</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Updating..." : "Update Blog"}
        </button>
      </form>
    </div>
  );
}

export default EditBlog;